<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import type { VariantProps } from 'tailwind-variants';
	import { tv } from '../tv';
	import { CONTAINER_COLOR_VARIANTS } from '../variants';

	export const dialogVariants = tv({
		base: 'w-full max-w-dialog-width animate-rise-5 overflow-hidden rounded-r400 border-b300 border-solid border-(--v-container-line) bg-(--v-container) text-(--v-on-container) shadow-e400',
		variants: { variant: CONTAINER_COLOR_VARIANTS },
		defaultVariants: { variant: 'Surface' }
	});

	export interface DialogProps
		extends Omit<HTMLAttributes<HTMLElement>, 'class'>, VariantProps<typeof dialogVariants> {
		as?: string;
		children?: Snippet;
		class?: ClassValue;
		ref?: HTMLElement | null;
	}
</script>

<script lang="ts">
	let {
		as = 'div',
		children,
		class: className,
		ref = $bindable(null),
		variant,
		...rest
	}: DialogProps = $props();
</script>

<svelte:element
	this={as}
	bind:this={ref}
	class={[dialogVariants({ variant }), className]}
	{...rest}
>
	{@render children?.()}
</svelte:element>
